import { useState } from 'react';

export default function News() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      alert('Obrigado por se inscrever! Você receberá nossas atualizações em breve.');
      setEmail('');
    }
  };

  return (
    <section id="news" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
              Notícias e Atualizações
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed">
              Fique por dentro das últimas novidades da Selem&Selem Participações
            </p>
          </div>

          <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-12 text-center shadow-xl">
            <i className="ri-newspaper-line text-6xl text-white mb-6"></i>
            <h3 className="text-3xl font-bold text-white mb-4">
              Receba Nossas Novidades
            </h3>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Inscreva-se para receber atualizações sobre nossos investimentos, projetos e insights do mercado
            </p>
            
            <form onSubmit={handleSubmit} className="max-w-md mx-auto">
              <div className="flex flex-col sm:flex-row gap-4">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Seu melhor e-mail"
                  required
                  className="flex-1 px-6 py-4 rounded-lg text-slate-800 text-sm focus:outline-none focus:ring-2 focus:ring-white"
                />
                <button
                  type="submit"
                  className="px-8 py-4 bg-slate-800 text-white font-semibold rounded-lg hover:bg-slate-900 transition-all whitespace-nowrap cursor-pointer"
                >
                  Inscrever-se
                </button>
              </div>
            </form>
          </div>

          <div className="mt-16 grid md:grid-cols-3 gap-8">
            <div className="bg-slate-50 rounded-xl p-6 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-line-chart-line text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-bold text-slate-800 mb-2">Análises de Mercado</h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                Insights e tendências dos setores onde atuamos
              </p>
            </div>

            <div className="bg-slate-50 rounded-xl p-6 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-rocket-line text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-bold text-slate-800 mb-2">Novos Projetos</h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                Acompanhe nossos investimentos e parcerias estratégicas
              </p>
            </div>

            <div className="bg-slate-50 rounded-xl p-6 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-lightbulb-line text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-bold text-slate-800 mb-2">Artigos Exclusivos</h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                Conteúdos sobre gestão, estratégia e inovação
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
